import { apiPutVerification } from "#api/ApiColaborador"
import { ButtonDialog, DialogGeneral } from "#common/Dialog"
import { Stack, Typography } from "@mui/material"
import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { reloadTable } from "app/pageSlice"
import dayjs from "dayjs"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

export default function DialogPersonalApproval(props) {
	const dispatch = useDispatch()
	const token = useSelector((state) => state.user.token)
	const [approval, setApproval] = useState(true)
	const [message, setMessage] = useState("")
	const fecha_alta = props?.colaborador.fecha_alta
	const [fecha, setFecha] = useState(fecha_alta ? dayjs(fecha_alta, "D-M-YYYY") : null)
	const { setOpen, reloadNow } = props
	const colaborador = props?.colaborador?.nombre_colaborador
	const id = props?.colaborador?.id
	const actualizar = () => {
		reloadNow()
		dispatch(reloadTable())
	}

	async function send() {
		const data = {
			id,
			verificado: approval ? true : null,
		}
		if (approval) data["fecha_alta"] = fecha?.format("YYYY-MM-DD")
		else data["message"] = message
		const { success } = await apiPutVerification(token, data)
		if (success) {
			actualizar()
			setOpen(false)
		}
	}

	const buttonsOption = [
		<ButtonDialog
			key={"cancelar"}
			label="Cancelar"
			onClick={() => setOpen(false)}
		/>,
		<ButtonDialog
			key={"enviar"}
			label="Enviar"
			onClick={() => send()}
		/>,
	]

	const handleChange = (newValue) => {
		setFecha(newValue)
	}
	let contenido = null

	if (approval)
		contenido = (
			<Stack>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<DesktopDatePicker
						label="Fecha de Ingreso"
						inputFormat="MM/DD/YYYY"
						value={fecha}
						onChange={handleChange}
						renderInput={(params) => <TextField {...params} />}
					/>
				</LocalizationProvider>
				<Typography variant="subtitle2">
					La fecha de ingreso es el dia que el colaborador empezó a trabajar{" "}
				</Typography>
			</Stack>
		)
	else
		contenido = (
			<TextField
				id="rechazo"
				label="Motivo del rechazo"
				variant="outlined"
				fullWidth
				value={message}
				onChange={(event) => {
					setMessage(event.target.value)
				}}
			/>
		)

	return (
		<DialogGeneral
			{...props}
			title={
				<Typography variant="h5">
					Aprobar Documentación
					<br />
					{colaborador}
				</Typography>
			}
			buttons={buttonsOption}
		>
			<Stack
				spacing={3}
				justifyContent="center"
				alignItems="center"
			>
				<FormControlLabel
					control={
						<Checkbox
							checked={approval}
							onChange={(event) => {
								setApproval(event.target.checked)
							}}
							// name="gilad"
						/>
					}
					label={approval ? "Aprobar" : "Rechazar"}
				/>
				{contenido}
			</Stack>
		</DialogGeneral>
	)
}
